import { ChangeDetectionStrategy, Component, computed, Signal } from '@angular/core';
import { EntityWithUuid, NkCardListItemAbstractComponent, NkCardListItemLink } from '@nk/ui-lib';

import { RouterModule } from '@angular/router';

function isNkCardListItemLink(item: unknown): item is NkCardListItemLink {
  return !!item && item.hasOwnProperty('routerLink') && item.hasOwnProperty('label');
}

@Component({
  selector: 'nk-card-list-item-link',
  imports: [RouterModule],
  templateUrl: './card-list-item-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardListItemLinkComponent<Entity extends EntityWithUuid> extends NkCardListItemAbstractComponent<Entity> {
  public links: Signal<NkCardListItemLink[] | null> = computed(() => {
    const value = this.valueSignal();
    if (value && value.entity && value.prop) {
      const item = value.entity && value.entity[value.prop];
      if (Array.isArray(item)) {
        if (item.some((item) => isNkCardListItemLink(item))) {
          return item;
        }
      } else {
        if (isNkCardListItemLink(item)) {
          return [item];
        }
      }
    }
    return null;
  });
}
